// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import { createEvent } from "effector";
import { UserInfoResponseDTO } from "../../api/backend-openapi";

export const setUsers = createEvent<UserInfoResponseDTO[]>("SET_USERS");
export const addUser = createEvent<UserInfoResponseDTO>("ADD_USER");
export const deleteUser = createEvent<string>("DELETE_USER");
export const updateUser = createEvent<UserInfoResponseDTO>("UPDATE_USER");
